import { render } from "./textAreaField.vue?vue&type=template&id=81523de4&scoped=true"
import script from "./textAreaField.vue?vue&type=script&lang=js"
export * from "./textAreaField.vue?vue&type=script&lang=js"

import "./textAreaField.vue?vue&type=style&index=0&id=81523de4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81523de4"]])

export default __exports__